module.exports = __webpack_public_path__ + "static/apple-icon-152x152-43400062e06b0461de49115d6f31b171.png";